module.exports = __webpack_public_path__ + "img/icon-arrows-back.36b433eb.svg";